import { gql } from "@apollo/client";


export const GET_STAFF_EVENT_OPEN_SESSIONS = gql`
    query StaffEventOpenSessions(
        $where: QueryWorkSessionsWhereWhereConditions
        $first: Int!
        $page: Int!
    ) {
        workSessions(
            where: $where
            orderBy: [{ column: ID, order: ASC }]
            first: $first
            page: $page
        ) {
            paginatorInfo {
                total
                currentPage
                lastPage
            }
            data {
                id
                ee_id
                user_id
                check_out_at
                getCheckOutStatus
            }
        }
    }
`;

export const GET_STAFF_EVENT_ELIGIBLE_WORKER_IDS = gql`
    query StaffEventEligibleWorkerIDs(
        $eeID: [ID!]!
        $where: QueryUsersWhereWhereConditions
        $first: Int!
        $page: Int!
    ) {
        users(
            ee_id: $eeID
            workersOnly: true
            where: $where
            orderBy: [{ column: ID, order: ASC }]
            first: $first
            page: $page
        ) {
            paginatorInfo {
                total
                currentPage
                lastPage
            }
            data {
                id
            }
        }
    }
`;
